export const VIEW_LABELS = ({ retailerName, params }) =>
  `/returns/${retailerName}/viewlabels?${params}`;

export const SEND_EMAIL = (retailerName) => `/returns/${retailerName}/email`;

export const VALIDATE_POSTAL_CODE = (params) => `/validate/zip?${params}`;

export const CANCEL_LABEL = ({ retailerName, encryptedReturnId }) =>
  `/returns/${retailerName}/deletelabel?return_id=${encryptedReturnId}`;

export const REASON_CODES = ({ retailerName, params }) =>
  `/returns/${retailerName}/reasoncodes?${params}`;

export const INVENTORY_INFO = ({ retailerName, itemId, params }) =>
  `returns/exchanges/${retailerName}/inventory/${itemId}?${params}`;

export const ORDER_ITEM_OPTIONS = ({ retailerName, itemId, orderNumber, params }) =>
  `returns/${retailerName}/returnoptions/order/${orderNumber}/item_id/${itemId}?${params}`;

export const RETURN_METHODS = ({ retailerName, locale }) =>
  `/returns/${retailerName}/returnmethods?locale=${locale}`;

export const MULTI_ORDER_RETURN_METHODS = ({ retailerName, params }) =>
  `/returns/multi-order/v1.0/${retailerName}/availableOptions?${params}`;

export const MULTI_ORDER_RETURN_SUBMIT = ({ retailerName, params }) =>
  `/returns/multi-order/v1.0/${retailerName}/submit-return?${params}`;

export const STORE_LOCATOR = ({ retailerName, orderNumber, params }) =>
  `/returns/locations/types/0/retailer/${retailerName}/order/${orderNumber}?${params}`;

export const LASSEN_LOCATIONS = (params) => `${window.LASSEN_URL}/api/v2.2/locations?${params}`;

export const REFUND_ESTIMATION = (retailerName) => `/returns/${retailerName}/estimates`;

export const UPLOAD_RETURNS_IMAGE = '/images/returns';

export const DELETE_RETURNS_IMAGE = (fileName) => `/images/returns/${fileName}/delete`;

export const UPLOAD_REPAIRS_IMAGE = '/images/repairs';

export const REPLACE_REPAIRS_IMAGE = (fileName) => `/images/repairs/${fileName}/replace`;

export const DELETE_REPAIRS_IMAGE = (fileName) => `/images/repairs/${fileName}/delete`;

export const REASONS_HIERARCHY = ({ retailerName, params }) =>
  `/returns/${retailerName}/reasons/hierarchy?${params}`;

export const ADDRESS_VALIDATION = '/carriers/api/usps/address/validate';

export const CREATE_PAYMENT_INTENT = `/api/v1/payments`;

export const VERIFY_ELIGIBILITY = (retailerName) =>
  `/returns/rules/v3/${retailerName}/eligibilties/item/b2b`;

export const LOCAL_PICKUP = ({ carrier, retailerName }) =>
  `/schedules/carrier/${carrier}/retailer/${retailerName}/pickups`;

export const ADDONS = ({ params, retailerName }) => `/api/v1/addons/${retailerName}?${params}`;

export const PICKUP_ADDON = ({ params, retailerName }) =>
  `/api/v1/addons/${retailerName}/pickups?${params}`;

export const SUBMIT_PICKUP = ({ retailerName }) => `/api/v1/addons/${retailerName}/pickups`;

export const PICKUP_DATA = ({ retailerName, params }) =>
  `/returns/${retailerName}/pickup/details?${params}`;

export const CARRIER_PICKUPS = ({ retailerName, carrier, params }) =>
  `/schedules/carrier/${carrier}/retailer/${retailerName}/pickups?${params}`;

export const CONSOLIDATED_METHODS = ({ retailerName, params }) =>
  `/returns/v1.0/${retailerName}/availableOptions?${params}`;

export const USER_PREFERENCES = ({ retailerName, params }) =>
  `/returns/v1.0/${retailerName}/userpreference?${params}`;

export const USER_DETAILS = ({ retailerName, params }) =>
  `/returns/v1.0/${retailerName}/userdetails?${params}`;

export const REASONS = ({ retailerName, orderNumber, params }) =>
  `/api/v1/reasons/${retailerName}/${orderNumber}?${params}`;

export const ELIGIBILITIES_ORDER = '/api/v1/eligibilities/order';

export const BORIS_STORE_DROP_OFF = (retailerName) => `/returns/${retailerName}/storedropoff`;

export const SUBMIT_CART = '/api/v1/submit/order';

export const CALCULATE_CART = ({ retailerName }) =>
  `/returns/sfccexchanges/${retailerName}/calculatecart`;

export const CREATE_DRAFT_ORDER = ({ retailerName }) =>
  `/returns/sfccexchanges/${retailerName}/createorder`;

export const GET_GB_FEATURE = ({ feature }) => `/returns/features/${feature}`;

export const DYNAMIC_CART = (retailerName) => `/api/v1/${retailerName}/returns/cart`;
